import { spring as spring$1 } from '@motionone/generators';
import { createGeneratorEasing } from '../create-generator-easing.es.js';
const spring = createGeneratorEasing(spring$1);
export { spring };